/**
 *
 * 方案汇报 - shp 文件加载 1.0
 *
 * 功能点:根据勾选加载shp路网
 * 场景:方案汇报
 *
 */
import Vue from "@/main";
/**
 * 路网变量
 * @var graphicLayer - 路网图层
 * @var shpObj - 选择的路网对象
 */
export let graphicLayer;
export let shpObj = [];
export let shpAll = [];

/**
 * 初始化
 * 清空所有数据
 * @returns { any }
 */
export function init() {
  if (shpObj.length > 0) {
    shpObj.forEach((item) => {
      console.log("路网删除", item);
      if (item.uid && Vue.$GLOBAL.map.getLayerById(item.uid) != undefined) {
        Vue.$GLOBAL.map.removeLayer(item.uid);
      }
    });
    shpObj = [];
  }
}
/**
 * 工具类
 * 简化geojson的坐标
 * @returns { any }
 */
export function notSimplifyGeoJSON(geojson) {
  //do nothing
  return geojson;
}
export function lowSimplifyGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.001,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}
export function mediumSimplifyGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.0001,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}
export function highSimplifyGeoJSON(geojson) {
  try {
    geojson = turf.simplify(geojson, {
      tolerance: 0.00001,
      highQuality: false,
      mutate: true,
    });
  } catch (e) {}
  return geojson;
}
/**
 *
 * 展示路网
 * @returns { any }
 */
export function showChinaLine(data, map = Vue.$GLOBAL.map, fn) {
  let { id } = data;
  let {
    shpName,
    shpUrl,
    shpColor,
    width,
    materialType,
    shpDistinct,
    dashLength,
    clampToGround,
    transparency,
    isOptimization,
    optimizationDegree,
    gapColor,
  } = data.shpInfo;
  if (materialType == "Water") {
    graphicLayer = new mars3d.layer.GeoJsonLayer({
      name: shpName,
      url: Vue.$GLOBAL.localResourcesPath + shpUrl,
      modelId: data.id,
      symbol: {
        type: "waterC",
        styleOptions: {
          height: 16, // 水面高度
          normalMap: "/images/waterNormals.jpg", // 水正常扰动的法线图
          frequency: 8000.0, // 控制波数的数字。
          animationSpeed: 0.02, // 控制水的动画速度的数字。
          amplitude: 5.0, // 控制水波振幅的数字。
          specularIntensity: 0.8, // 控制镜面反射强度的数字。
          baseWaterColor: "#006ab4", // rgba颜色对象基础颜色的水。#00ffff,#00baff,#006ab4
          blendColor: "#006ab4", // 从水中混合到非水域时使用的rgba颜色对象。
          opacity: 0.4, // 透明度
          clampToGround: true, // 是否贴地
        },
      },
    });
    map.addLayer(graphicLayer);
  } else {
    console.log(shpUrl);
    let color = shpColor;
    let simplifyFunc = notSimplifyGeoJSON;
    let terrain = {};
    if (Vue.$route.params.stype.indexOf("sandbox") >= 0) {
      if (window.sessionStorage.getItem("nowProjectId") == "255513056948293")
        terrain = {
          classificationType: Cesium.ClassificationType.TERRAIN,
        };
    }
    if (isOptimization != undefined && !isOptimization) {
      simplifyFunc = notSimplifyGeoJSON;
    } else {
      if (optimizationDegree != undefined) {
        switch (optimizationDegree) {
          case "low":
            simplifyFunc = lowSimplifyGeoJSON;
            break;
          case "medium":
            simplifyFunc = mediumSimplifyGeoJSON;
            break;
          case "high":
            simplifyFunc = highSimplifyGeoJSON;
            break;
          default:
            simplifyFunc = notSimplifyGeoJSON;
            break;
        }
      }
    }
    graphicLayer = new mars3d.layer.GeoJsonLayer({
      name: shpName,
      modelId: id,
      //url: "/baseIP/" + shpUrl,
      url: Vue.$GLOBAL.localResourcesPath + shpUrl,
      format: simplifyFunc, // 用于自定义处理geojson
      symbol: {
        type: "polylineC",
        styleOptions: {
          clampToGround,
          width: width,
          distanceDisplayCondition: true,
          distanceDisplayCondition_far: shpDistinct || 1000000,
          distanceDisplayCondition_near: 0,
          width: width,
          materialType: materialType,
          materialOptions: {
            color: color,
            opacity: 0.9,
            dashLength: dashLength,
            image: "/img/textures/LinkPulse.png",
            glowPower: 0.06,
            speed: 3,
            gapColor: gapColor ? gapColor : Cesium.Color.TRANSPARENT,
          },
          ...terrain,
        },
      },
      popup: `&nbsp;&nbsp; ${shpName} &nbsp;&nbsp;`,
      // flyTo: true,
    });

    map.addLayer(graphicLayer);
  }

  // 绑定事件
  graphicLayer.on(mars3d.EventType.load, function(event) {
    console.log("数据加载完成", event);
    Vue.$NProgress.done(true);
    if (fn) fn(event);
  });
}
/**
 *
 * 删除路网
 * @returns { any }
 */
export function hideChinaLine(id, map) {
  map.removeLayer(id);
  Vue.$NProgress.done(true);
}

export function getshpAll(data) {
  const list = [];
  data.forEach((item) => {
    if (item.children.length > 0) {
      item.children.forEach((etem) => {
        list.push(etem);
      });
    }
  });
  shpAll = list;
  console.log(shpAll);
}
/**
 *
 * 通过id查找路网，添加或者删除
 * @returns { any }
 */
export function showChinaLineId(property, id, fn, ...list) {
  let map = Vue.$GLOBAL.map;
  if (list.length > 0 && list[0] != undefined) {
    let { mapType } = list[0];
    console.log(mapType);
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
    }
  }
  Vue.$NProgress.configure({
    easing: "ease",
    showSpinner: true,
  });
  Vue.$NProgress.set(0.8).inc(0.2);
  if ((typeof property == "boolean" && property) || property == "true") {
    if (map.getLayer(id, "modelId")) {
      return;
    }
    let data = shpAll.find((item) => {
      if (item.id == id) {
        return item;
      }
    });
    if (data) {
      showChinaLine(data, map, (event) => {
        shpObj.push({
          id: event.layer.options.modelId,
          uid: event.layer.uuid,
        });
      });
    } else {
      Vue.$NProgress.done(true);
    }
  } else {
    let uid;
    shpObj.find((item, i) => {
      if (item.id == id) {
        uid = item.uid;
      }
    });
    hideChinaLine(uid, map);
  }
}
